/**
 * Purpose:
 *   Tailwind style constants for the shared not-found content layout.
 */

export const notFoundStyles = {
  container: `
    mt-16 flex flex-col items-center justify-center
    gap-4 px-4 text-center bg-background
  `,
  code: `
    text-6xl font-bold text-green-500
  `,
  title: `
    text-2xl font-semibold text-neutral-500
  `,
  cta: `
    inline-flex items-center gap-2
    px-6 py-3 rounded-lg
    bg-green-500 text-white font-medium
    hover:bg-green-400 transition-colors
  `,
};
